module.exports = __webpack_public_path__ + "img/talent_step4.01d6248f.png";